// Utility function to get the correct URL path taking the currently
// selected language into account.
function getPath(lang, suffix) {
  let path = suffix;
  const segments = path.split('/');

  if (!suffix.startsWith('/')) {
    const url = new URL(window.location);

    path = `${url.pathname}/${suffix}`;
  } else if (typeof lang === 'string' && lang !== '' && segments[1] !== lang) {
    let computedSuffix = suffix;

    // If the suffix is the root it can be omitted. This helps prevent us from
    // linking to routes with trailing slashes which Google indexes separately.
    if (suffix === '/') {
      computedSuffix = ''
    }

    path = `/${lang}${computedSuffix}`;
  }

  return path;
}

export default getPath;
